import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import confetti from "canvas-confetti";
import { quoteMessage } from "../../services/constants";

const getRandomQuote = () => {
  const randomIndex = Math.floor(Math.random() * quoteMessage.length);
  return quoteMessage[randomIndex];
};

const randomQuote = getRandomQuote();

const CheckInDone = () => {
  const [showLightbox, setShowLightbox] = useState(false);
  const [showSocialIcons, setShowSocialIcons] = useState(false);

  useEffect(() => {
    const confettiTimeout = setTimeout(() => {
      confetti();
    }, 100);

    return () => clearTimeout(confettiTimeout);
  }, []);

  const handleShare = () => {
    setShowSocialIcons(true);
  };

  const handleSocialShare = (platform) => {
    const quotedTextElement = document.querySelector(".quoted-text");
    if (quotedTextElement) {
      html2canvas(quotedTextElement).then((canvas) => {
        const imageData = canvas.toDataURL("image/png");
        let shareUrl = "";

        switch (platform) {
          case "facebook":
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
            break;
          case "twitter":
            shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`;
            break;
          case "instagram":
            alert("Instagram sharing is not supported directly.");
            return;
          case "tiktok":
            alert("TikTok sharing is not supported directly.");
            return;
          default:
            return;
        }

        window.open(shareUrl, "_blank");
      });
    }
    setShowLightbox(true);
  };

  return (
    <div className="modal-container animated-onboarding">
      <div className="quoted-text p-40">
        <div className="modal-container-title heading">
          <div className="tag-container">
            <span className="tag">Did You Know</span>
          </div>
          <h3>{randomQuote}</h3>
        </div>
        <div className="divider-line fade-fast"></div>
        <div className="modal-contect-title label flex jc-spacebetween ai-center">
          <div>
            <p>Track your recovery journey</p>
            <p>www.engivio.com</p>
          </div>
          <div>
            <img src="./engivioCircle.png" alt="Engivio Logo" />
          </div>
        </div>
      </div>

      <div className="nav-container fade-3 flex fd-column centered-texts">
        <button className="btn-next next-btn fade-3" onClick={handleShare}>
          Share <img src="./shareBtn.png" />
        </button>
        {showSocialIcons && (
          <div className="social-icons">
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/facebook.svg" alt="Facebook" onClick={() => handleSocialShare("facebook")} style={{ width: "30px", cursor: "pointer" }} />
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/twitter.svg" alt="Twitter" onClick={() => handleSocialShare("twitter")} style={{ width: "30px", cursor: "pointer" }} />
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/instagram.svg" alt="Instagram" onClick={() => handleSocialShare("instagram")} style={{ width: "30px", cursor: "pointer" }} />
            <img src="https://cdn.jsdelivr.net/npm/simple-icons@v5/icons/tiktok.svg" alt="TikTok" onClick={() => handleSocialShare("tiktok")} style={{ width: "30px", cursor: "pointer" }} />
          </div>
        )}
        <a className="mt-10 fade-3 return" href="/">
          Return to homepage
        </a>
      </div>
    </div>
  );
};

export default CheckInDone;
